import { useState, useEffect } from 'react';
import '../styles/responsive.css';


// Viewport breakpoints (px) — single source of truth (custom properties
// can't be read inside @media conditions, so these are NOT in tokens.css).
export const BREAKPOINTS = {
    mobile: 1000,
    small: 1400,
    medium: 1700,
};

/** Compact desktop stats: panel container width (rem), not viewport. */
export const COMPACT_STATS_DESKTOP = {
    oneColMaxWidthRem: 52,
    subcolumnMinRem: 11,
};

// Hook to detect screen size and provide responsive utilities
export const useResponsive = () => {
    const [screenSize, setScreenSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    const [breakpoint, setBreakpoint] = useState('medium');

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            const height = window.innerHeight;

            setScreenSize({ width, height });

            // Determine breakpoint
            if (width < BREAKPOINTS.mobile) {
                setBreakpoint('mobile');
            } else if (width < BREAKPOINTS.small) {
                setBreakpoint('small');
            } else if (width < BREAKPOINTS.medium) {
                setBreakpoint('medium');
            } else {
                setBreakpoint('wide');
            }
        };

        // Set initial size
        handleResize();

        // Add event listener
        window.addEventListener('resize', handleResize);

        // Cleanup
        return () => window.removeEventListener('resize', handleResize);
    }, []);


    // Utility functions
    const isMobile = breakpoint === 'mobile';
    const isSmall = breakpoint === 'small';
    const isMedium = breakpoint === 'medium';
    const isWide = breakpoint === 'wide';
    const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    return {
        screenSize,
        breakpoint,
        isMobile,
        isSmall,
        isMedium,
        isWide,
        isTouch,
        BREAKPOINTS,
    };
}; 